import React from "react"
import { useTranslation } from 'react-i18next'
import { QRCodeSVG } from 'qrcode.react'

import { API_BASE } from 'helpers/api'

/**
 * A5 PLAKAT — ofis devoriga osiladi.
 *
 * DIZAYN (3-tahrir, 2026-08-17): korxonaning O'Z REKLAMA USLUBIGA moslandi.
 * Foydalanuvchi bannerini ko'rsatdi — u yerda:
 *   to'q (deyarli qora) fon · mahsulot FOTOSI · oq logotip chap yuqorida ·
 *   o'ng yuqorida shior · pastda chapda telefon, o'ngda ijtimoiy tarmoq nomi.
 * Plakat aynan shu tuzilishda.
 *
 * ⚠️ Orqa fon — DASTUR CHIZGAN NAQSH EMAS, korxona YUKLAGAN rasm. Ilgari
 *    profnastil naqshini chizib ko'rgandik, brend uslubiga tushmadi.
 * ⚠️ Logotip `filter: brightness(0) invert(1)` bilan OQ qilinadi: saqlangan
 *    fayl to'q rangli, to'q fonda ko'rinmay qolardi. Bir rangli logotip uchun
 *    bu usul aniq ishlaydi (bannerdagi ko'rinishning aynan o'zi).
 * ⚠️ QR OQ kartochkada qoladi — skaner to'q fondagi QR ni ishonchli o'qimaydi.
 */
function Poster({ data, posterRef }) {
	const { t } = useTranslation()

	const url = data?.bot_url
	/* Fayllar SHU backenddan olinadi (prodda ham, lokalda ham to'g'ri ishlaydi).
	   Logotip lokal muhitda bo'lmasligi mumkin (u prod serverda) — shuning uchun
	   rasm yuklanmasa prod manziliga o'tadi (onError). */
	/* Rasmlar avval javob ichidagi `data:` dan olinadi — «Yuklab olish» boshqa
	   domendagi rasmni canvasga chiza olmaydi (CORS), shunda fon tushib qolardi.
	   Eski javob (yoki fayl o'chib ketgan) bo'lsa oddiy manzilga qaytiladi. */
	const logoUrl = data?.logo_data || (data?.logo ? fileUrl('poses', data.logo) : null)
	const bgUrl = data?.poster_bg_data || (data?.poster_bg ? fileUrl('poster', data.poster_bg) : null)

	/* Bot nomi — `bot_url` (https://t.me/xxx_bot) dan ajratiladi. Backend
	   `complaint_bot_username` ni Telegramning getMe sidan oladi. */
	const botName = url ? String(url).replace(/^https?:\/\/t\.me\//i, '').replace(/\/.*$/, '') : null

	return (
		<div ref={posterRef} className="cposter">
			<style>{`
				@page { size: A5 portrait; margin: 0; }
				.cposter {
					width: 148mm; height: 210mm; box-sizing: border-box;
					background: #0d0f12; color: #fff; position: relative; overflow: hidden;
					font-family: 'Segoe UI', Roboto, Arial, sans-serif;
					display: flex; flex-direction: column;
					-webkit-print-color-adjust: exact; print-color-adjust: exact;
				}
				/* Mahsulot fotosi — butun varaqni qoplaydi */
				.cposter .cp-photo {
					position: absolute; inset: 0;
					background-image: ${bgUrl ? `url("${bgUrl}")` : 'none'};
					background-size: cover; background-position: center;
				}
				/* Qorayтirish — oq matn har qanday rasmda o'qilsin.
				   Yuqori va past to'qroq, o'rtasi biroz ochiq (foto ko'rinsin). */
				.cposter .cp-shade {
					position: absolute; inset: 0;
					background: linear-gradient(180deg,
						rgba(8,10,13,.92) 0%, rgba(8,10,13,.55) 26%,
						rgba(8,10,13,.55) 62%, rgba(8,10,13,.95) 100%);
				}
				.cposter .cp-inner {
					position: relative; z-index: 2; flex: 1;
					display: flex; flex-direction: column; padding: 10mm 11mm 9mm;
				}

				/* YUQORI QATOR — logotip | shior */
				.cposter .cp-top { display: flex; align-items: center; justify-content: space-between; gap: 6mm; }
				.cposter .cp-logo {
					height: 15mm; max-width: 62mm; object-fit: contain; object-position: left center;
					filter: brightness(0) invert(1);
				}
				.cposter .cp-brand { font-size: 15pt; font-weight: 800; letter-spacing: 1px; }
				.cposter .cp-slogan {
					font-size: 13pt; font-weight: 700; text-align: right; line-height: 1.2;
				}

				/* MARKAZ — sarlavha va QR */
				.cposter .cp-mid {
					flex: 1; display: flex; flex-direction: column;
					align-items: center; justify-content: center; text-align: center;
				}
				.cposter .cp-title {
					font-size: 29pt; font-weight: 800; line-height: 1.02; letter-spacing: -0.5px;
					text-shadow: 0 2px 12px rgba(0,0,0,.55);
				}
				.cposter .cp-sub {
					font-size: 12pt; opacity: .9; margin-top: 2.5mm;
					text-shadow: 0 1px 8px rgba(0,0,0,.5);
				}
				.cposter .cp-qr {
					margin-top: 6mm; background: #fff; padding: 4.5mm; border-radius: 3mm;
					line-height: 0; box-shadow: 0 6px 24px rgba(0,0,0,.45);
				}
				.cposter .cp-scan {
					margin-top: 3.5mm; font-size: 10.5pt; opacity: .9;
					display: flex; align-items: center; gap: 2mm; justify-content: center;
				}
				/* Bot nomi — QR ostida, skanerlay olmagan odam qidiruvdan topsin */
				.cposter .cp-bot {
					margin-top: 1.5mm; font-size: 12pt; font-weight: 700;
					letter-spacing: .5px; opacity: .95;
				}

				/* PAST QATOR — telefon | mas'ul odam */
				.cposter .cp-bottom {
					display: flex; align-items: flex-end; justify-content: space-between; gap: 6mm;
				}
				.cposter .cp-phone-label {
					font-size: 8.5pt; letter-spacing: 2.5px; text-transform: uppercase; opacity: .65;
				}
				.cposter .cp-phone {
					font-size: 22pt; font-weight: 800; line-height: 1.1; white-space: nowrap;
				}
				.cposter .cp-person { font-size: 12pt; font-weight: 600; opacity: .92; text-align: right; }
				.cposter .cp-addr { font-size: 9.5pt; opacity: .6; text-align: right; }

				.cposter .cp-empty {
					margin-top: 6mm; border: 2px dashed rgba(255,255,255,.35);
					padding: 10mm 6mm; font-size: 11pt; border-radius: 3mm; opacity: .85;
				}
				.cposter .cp-nobg {
					position: absolute; z-index: 3; left: 0; right: 0; bottom: 0;
					background: rgba(255,193,7,.92); color: #14171c; font-size: 9.5pt;
					padding: 2mm 4mm; text-align: center; font-weight: 600;
				}
			`}</style>

			<div className="cp-photo"></div>
			<div className="cp-shade"></div>

			<div className="cp-inner">
				<div className="cp-top">
					{logoUrl
						? <img className="cp-logo" src={logoUrl} alt=""
							onError={(e) => {
								// Lokal muhitda logotip fayli yo'q — prod serveridan olamiz
								if (e.target.dataset.fallback) return
								e.target.dataset.fallback = '1'
								e.target.src = `https://backend.tameer.uz/uploads/poses/${data.logo}`
							}} />
						: <div className="cp-brand">{data?.pos_name || ''}</div>
					}
					<div className="cp-slogan">{t('poster_slogan')}</div>
				</div>

				<div className="cp-mid">
					<div className="cp-title">{t('poster_title')}</div>
					<div className="cp-sub">{t('poster_subtitle')}</div>

					{url ? (
						<>
							<div className="cp-qr">
								<QRCodeSVG value={url} size={185} level="M" />
							</div>
							<div className="cp-scan">
								<CameraIcon />
								<span>{t('poster_scan')}</span>
							</div>
							{/* BOT NOMI — QR skanerlanmasa (eski telefon, singan kamera)
							    mijoz uni Telegram qidiruviga qo'lda yozib topa oladi. */}
							{!!botName && <div className="cp-bot">@{botName}</div>}
						</>
					) : (
						<div className="cp-empty">{t('poster_no_bot')}</div>
					)}
				</div>

				<div className="cp-bottom">
					<div>
						{!!data?.responsible_phone &&
							<>
								<div className="cp-phone-label">{t('poster_call')}</div>
								<div className="cp-phone">{formatPhone(data.responsible_phone)}</div>
							</>
						}
					</div>
					<div>
						{!!data?.responsible_name &&
							<div className="cp-person">{data.responsible_name}</div>
						}
						{!!data?.address &&
							<div className="cp-addr">{data.address}</div>
						}
					</div>
				</div>
			</div>

			{!bgUrl &&
				<div className="cp-nobg d-print-none">{t('poster_bg_missing')}</div>
			}
		</div>
	)
}

/**
 * Backenddagi fayl manzili.
 *
 * ⚠️ Ilgari manzil `window.location.hostname + ':8000'` dan qurilardi. Lokalda
 *    to'g'ri ishlardi, PRODDA esa `https://tameer.uz:8000/...` chiqib ketardi —
 *    u port serverda ochiq emas, shuning uchun plakat orqa foni umuman
 *    ko'rinmasdi (fayl serverda bor bo'lsa ham). Endi manzil `helpers/api`
 *    dagi YAGONA manbadan olinadi: prodda `https://backend.tameer.uz`.
 */
function fileUrl(folder, name) {
	return API_BASE + '/uploads/' + folder + '/' + name
}

/**
 * Telefonni O'QILADIGAN qilib ajratadi: 998889911900 -> +998 88 991 19 00
 * Plakat devorda turadi, odam raqamni ko'z bilan o'qib teradi — yopishgan
 * 12 raqamdan adashish oson. O'zbek raqami bo'lmasa tegilmaydi.
 */
function formatPhone(raw) {
	if (!raw) return raw
	const d = String(raw).replace(/\D/g, '')

	if (d.length === 12 && d.startsWith('998')) {
		return `+998 ${d.slice(3, 5)} ${d.slice(5, 8)} ${d.slice(8, 10)} ${d.slice(10, 12)}`
	}
	if (d.length === 9) {
		return `+998 ${d.slice(0, 2)} ${d.slice(2, 5)} ${d.slice(5, 7)} ${d.slice(7, 9)}`
	}
	return raw
}

function CameraIcon() {
	return (
		<svg width="16" height="16" viewBox="0 0 24 24" fill="none" style={{ flex: 'none' }}>
			<path d="M4 8.5A2.5 2.5 0 0 1 6.5 6h1.2l1-1.6A1 1 0 0 1 9.5 4h5a1 1 0 0 1 .85.4L16.3 6h1.2A2.5 2.5 0 0 1 20 8.5v7A2.5 2.5 0 0 1 17.5 18h-11A2.5 2.5 0 0 1 4 15.5v-7Z"
				stroke="#fff" strokeOpacity="0.9" strokeWidth="1.6" />
			<circle cx="12" cy="12" r="3.2" stroke="#fff" strokeOpacity="0.9" strokeWidth="1.6" />
		</svg>
	)
}

export default Poster
